export const PLACE_RESULT_FEATURE_TYPE = {
  AVAILABLE: 'AVAILABLE',
  DISABLED: 'DISABLED',
  FAILED: 'FAILED',
} as const;
